<mat-toolbar class="content-header">
  <h1 class="page-title">
    <mat-icon fontIcon="gpp_maybe"></mat-icon>
    {{ "risks.title" | translate }}
  </h1>
  <span class="toolbar-spacer"></span>

  <lib-button *ngIf="mode == 'map'" [matMenuTriggerFor]="menu" [icon]="'map'" matTooltip="display">
  </lib-button>

  <lib-button *ngIf="mode == 'list'" [matMenuTriggerFor]="menu" [icon]="'view_list'" matTooltip="display">
  </lib-button>

  <lib-button *ngIf="mode == 'commented_list'" [matMenuTriggerFor]="menu" [icon]="'comment'" matTooltip="display">
  </lib-button>

  <lib-button *ngIf="mode == 'invalidated_list'" [matMenuTriggerFor]="menu" [icon]="'visibility_off'" matTooltip="display">
  </lib-button>

  <!-- Menus -->
  <mat-menu #menu="matMenu" class="modern-menu">
    <button mat-menu-item (click)="setMode('map')" class="menu-item">
      <mat-icon class="icon">map</mat-icon>
      {{ 'risks.map_mode' | translate }}
    </button>

    <button mat-menu-item (click)="setMode('list')" class="menu-item">
      <mat-icon class="icon">view_list</mat-icon>
      {{ 'risks.list_mode' | translate }}
    </button>

    <button mat-menu-item (click)="setMode('commented_list')" class="menu-item">
      <mat-icon class="icon">comment</mat-icon>
      {{ 'risks.comment_list_mode' | translate }}
    </button>

    <button mat-menu-item (click)="setMode('invalidated_list')" class="menu-item">
      <mat-icon class="icon">visibility_off</mat-icon>
      {{ 'risks.invalidated_list' | translate }}
    </button>
  </mat-menu>

  <lib-button [text]="'risks.export' | translate" [color]="'secondary'" [icon]="'download'" (click)="exportPDF()"
    class="download" [loading]="loadingPDF" [disabled]="!risks.length"
    [current]="exportCurrent" [total]="exportTotal">
  </lib-button>
</mat-toolbar>

<div class="tab-menu">
  <div class="date-picker">
    <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_left" (click)="navigateDate(-1)">
    </lib-button>

    <app-date-picker *ngIf="!showEndDate" [startDate]="startDate" [min]="project?.createdDate"
      [activity]="activitySignal()" (dateChanged)="onPickerChanged($event)" [hideTime]="true">
    </app-date-picker>

    <app-range-picker *ngIf="showEndDate" [startDate]="startDate" [endDate]="endDate"
      (change)="onRangePickerChanged($event)" [activity]="activitySignal()">
    </app-range-picker>

    <lib-button *ngIf="!showEndDate" size="small" color="none" icon="date_range" (click)="onShowEndChange()">
    </lib-button>

    <lib-button *ngIf="showEndDate" size="small" color="none" icon="close" (click)="onShowEndChange()">
    </lib-button>

    <lib-button *ngIf="startDate" size="small" color="none" icon="keyboard_arrow_right" (click)="navigateDate(1)">
    </lib-button>
  </div>

  <div *ngIf="riskFilters.risk.length" class="filter-container">
    <lib-button [text]="riskButtonText" [color]="'outline'" (click)="onShowFilter('risk')"></lib-button>

    <!-- <button mat-stroke-button  (click)="onShowFilter('risk')">
      <mat-icon>filter_list</mat-icon>
      <span>{{ "risks.list" | translate }} {{ riskFilters.risk.length }}/{{
        riskList.length
        }}</span>
    </button> -->

    <ul class="filter-list" *ngIf="showFilter == 'risk'">
      <li *ngFor="let item of riskList">
        <mat-checkbox type="checkbox" [(ngModel)]="item.value" (change)="onFilterChange()"
          *ngIf="item.value != 'disable'">{{ getDisplayName(item.key) }}
        </mat-checkbox>
        <mat-checkbox type="checkbox" checked="true" *ngIf="item.value == 'disable'" disabled>{{
          getDisplayName(item.key) }}
        </mat-checkbox>
      </li>
    </ul>
  </div>

  <div *ngIf="riskFilters.zone.length" class="filter-container">
    <lib-button [text]="zoneButtonText" [color]="'outline'" (click)="onShowFilter('zone')"></lib-button>

    <!-- <button mat-stroke-button color="primary" (click)="onShowFilter('zone')">
      <mat-icon>filter_list</mat-icon>
      <span>{{ "risks.zone" | translate }} {{ riskFilters.zone.length }}/{{
        zoneList.length
        }}</span>
    </button> -->

    <ul class="filter-list" *ngIf="showFilter == 'zone'">
      <li *ngFor="let item of zoneList">
        <mat-checkbox type="checkbox" [(ngModel)]="item.value" (change)="onFilterChange()"
          *ngIf="item.value != 'disable'">{{ item.key }}
        </mat-checkbox>
        <mat-checkbox type="checkbox" checked="true" *ngIf="item.value == 'disable'" disabled>{{ item.key }}
        </mat-checkbox>
      </li>
    </ul>
  </div>

  <div *ngIf="riskFilters.sequence.length" class="filter-container">
    <lib-button [text]="sequenceButtonText" [color]="'outline'" (click)="onShowFilter('sequence')"></lib-button>
    <!-- <button matButton="filled" color="primary" (click)="onShowFilter('sequence')">
      <mat-icon>filter_list</mat-icon>
      <span>{{ "risks.sequence" | translate }} {{ riskFilters.sequence.length }}/{{
        sequenceList.length
        }}</span>
    </button> -->

    <ul class="filter-list" *ngIf="showFilter == 'sequence'">
      <li *ngFor="let item of sequenceList">
        <mat-checkbox type="checkbox" [(ngModel)]="item.value" (change)="onFilterChange()"
          *ngIf="item.value != 'disable'">{{ item.key }}
        </mat-checkbox>
        <mat-checkbox type="checkbox" checked="true" *ngIf="item.value == 'disable'" disabled>{{ item.key }}
        </mat-checkbox>
      </li>
    </ul>
  </div>

  <div class="devices">
    <mat-form-field appearance="outline">
      <mat-label>{{'units.tracker' | translate}} </mat-label>
      <mat-select [(ngModel)]="selectedUnits" name="trackerIds" multiple (selectionChange)="filterByTracker($event)">
        <mat-option [value]="unit.id" *ngFor="let unit of units">{{unit.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="risk-count">
    {{filteredRisks.length}}/{{risks.length}} {{ "risks.risk_to_display" | translate }}
  </div>
</div>

<app-map-mode *ngIf="mode=='map'" [loading]="loading" [startDate]="startDate" [endDate]="endDate" [modelId]="modelId"
  [project]="project" [risksObs]="getRisksObs()" [riskFiltersObs]="getRiskFiltersObs()" [user]="currentUser()"
  (onExport)="onExport($event)" (onLoaded)="onMapLoaded($event)">
</app-map-mode>

<app-list-mode *ngIf="mode!='map'" [mode]="mode" [loading]="loading" [startDate]="startDate" [endDate]="endDate"
  [modelId]="modelId" [project]="project" [risksObs]="getRisksObs()" [riskFiltersObs]="getRiskFiltersObs()"
  [user]="currentUser()" (onExport)="onExport($event)">
</app-list-mode>
